import { vue2Adaptor } from '@mcfe/mfe-core-adaptors';
import Vue from 'vue';
import '__src/common/index.js';
import App from 'pages/recover/index.vue';
export const { mount, bootstrap, unmount, update } = vue2Adaptor({
    Vue,
    rootComponent: App,
    appOptions: {
        el: '#app',
        mode: 'qiankun'
    }
});
